var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600.1 800",
    style: {
      enableBackground: "new 0 0 600.1 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,750.4V400c0-13.9,4.8-25.6,14.4-35.2s21.6-14.4,36-14.4v-100c0-45.3,11.2-87.2,33.6-125.6s52.5-68.8,90.4-91.2 S254.2,0,300,0c60.3,0,113.3,18.9,159.2,56.8s74.4,85.6,85.6,143.2h-104c-10.1-29.3-28-53.3-53.6-72c-25.6-18.7-54.7-28-87.2-28 c-41.6,0-77.1,14.7-106.4,44s-43.7,64.8-43.2,106.4v100h400c13.3,0,25.1,4.8,35.2,14.4c10.1,9.6,14.9,21.3,14.4,35.2v350.4 c0,13.9-4.8,25.6-14.4,35.2c-9.6,9.6-21.3,14.4-35.2,14.4h-500c-13.9,0-25.9-4.8-36-14.4S-0.5,764.3,0,750.4L0,750.4z M100,700h400 V450.4H100V700z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock_icon.5fc635ac5e173d2f7b3125d6eb9bd2ce.svg";
export { ForwardRef as ReactComponent };